<template>
  <div class="distribution-detail">
    <el-dialog
      title="推荐分布"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="formLine">
        <el-row :gutter="15">
          <el-col :span="8" :md="8">
            <el-form-item label="" prop="name">
              <el-input
                v-model="formLine.name"
                placeholder="搜索商品/商户/厂家"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8">
            <el-form-item label="" prop="date">
              <el-date-picker
                style="width: 80%"
                v-model="formLine.date"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                :picker-options="pickerOptions"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="6">
            <el-form-item>
              <el-button type="primary" @click="handleQuery">查询</el-button>
              <el-button type="primary" @click="handleReset">重置</el-button>
              <!-- <el-button size="small" style="float: right" @click="handleExport"
                  >导出</el-button
                > -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 页签 -->
      <div class="tabs-row">
        <el-radio-group
          v-model="tabType"
          style="margin-bottom: 10px"
          @change="onTabChange"
        >
          <el-radio-button label="total">汇总</el-radio-button>
          <el-radio-button label="detail">明细</el-radio-button>
        </el-radio-group>
      </div>
      <!--汇总 -->
      <div
        v-if="tabType == 'total' && charts && charts.length > 0"
        class="charts-row"
        v-loading="loading"
      >
        <highcharts
          v-for="(chart, index) in charts"
          :key="index"
          :ref="`chart${index}`"
          :options="chart"
          class="chart-item"
        ></highcharts>
      </div>
      <!-- 明细 -->
      <div v-if="tabType == 'detail'" class="charts-detail">
        <MyTable
          :table-data="tableData"
          :page="page"
          :index="false"
          :table-option.sync="tableOption"
          @page-change="getDistributionList"
          @sort-change="sortChange"
          v-loading="listLoading"
          :max-height="'300px'"
        >
          <template slot="clik_cvr" slot-scope="scope">
            {{
              scope.row.clik_cvr
                ? parseFloat(scope.row.clik_cvr * 100).toFixed(4) + "%"
                : ""
            }}
          </template>
          <template slot="status" slot-scope="scope">
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              class="btn"
              @click="handleDetail(scope.row)"
              >搜索趋势</el-link
            >
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              class="btn"
              @click="handleDistributionDetail(scope.row)"
              >推荐分布</el-link
            >
          </template>
        </MyTable>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryGoodsSalesEcharts, excelExport } from "@/api/statistics";
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts-no-data-to-display";
HighchartsNoData(Highcharts);

//  推荐分布
import MyTable from "@/components/myTable";
export default {
  name: "",
  data() {
    return {
      formLine: {
        name: "",
        date: [],
      },
      shopChartOptions: {},
      factoryChartOptions: {},
      activityChartOptions: {},
      charts: null,
      dialogVisible: false,
      tabType: "total",
      tableData: [],
      tableOption: [
        {
          label: "商户名称",
          prop: "shop_name",
        },
        {
          label: "商品",
          prop: "goods_name",
        },
        {
          label: "厂家",
          prop: "goods_factory",
        },
        {
          label: "活动类型",
          prop: "activity_type_name",
        },
        {
          label: "价格",
          prop: "price",
          sortable: "custom",
        },
        {
          label: "点击量",
          prop: "click_cnt",
          sortable: "custom",
        },
        {
          label: "销量",
          prop: "order_cnt",
          sortable: "custom",
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 30,
        pageSizes: [30, 50, 100, 500],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      order: "1",
      charts: [],
      shopCharts: null,
      factoryCharts: null,
      activeCharts: null,
      loading: false,
      listLoading: false,
      orderType: 124, // 列表升降序type
    };
  },
  components: { MyTable },
  mounted() {
    // this.setupOptions();
  },
  methods: {
    init(row) {
      console.log("init----", row);
      this.tabType = "total";
      this.formLine.keyword = row.keyword;
      this.dialogVisible = true;
      this.handleReset();
      this.handleQuery();
    },
    onTabChange() {
      this.handleReset();
      this.handleQuery();
    },
    // 表格排序

    // 表格排序
    sortChange(val) {
      this.order = this.getOrder(val.prop);
      if (val.order == "ascending") {
        this.orderType = 124;
      } else {
        this.orderType = 126;
      }
      this.getDistributionList();
    },
    // 根据选择的字段获取请求参数
    getOrder(val) {
      let getValue = "1";
      switch (val) {
        case "price":
          getValue = "1";
          break;
        case "click_cnt":
          getValue = "2";
          break;
        case "order_cnt":
          getValue = "4";
          break;
        default:
          getValue = "1";
          break;
      }
      return getValue;
    },
    // 获取明细数据
    getDistributionList() {
      this.handleQuery();
    },
    //查询
    handleQuery() {
      let params = this.getParam();
      // 后续需要优化，使用一个方法
      if (this.tabType == "total") {
        // 商家
        this.getShopCharts(params);
        //
        this.getActiivtyCharts(params);
        //
        this.getFactoryCharts(params);
      }
      if (this.tabType == "detail") {
        this.getTableData(params);
        this.getTableTotal(params);
      }
    },
    // 获取请求参数
    getParam(type) {
      //  [关键词,开始时间,开始时间,结束时间,结束时间,商户名称,商户名称,排序字段,每页行数,第几行开始]
      const date1 = this.correctData(this.formLine.date[0]).replace(/-/g, "");
      const date2 = this.correctData(this.formLine.date[1]).replace(/-/g, "");
      const keyword = this.formLine.keyword || "";
      return [
        keyword,
        date1,
        date1,
        date2,
        date2,
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.formLine.name),
        this.correctData(this.order),
        this.page.size,
        (this.page.current - 1) * 30,
      ];
    },
    // 格式化数据
    correctData(data) {
      return data || "";
    },
    // 请求图表数据
    getShopCharts(params) {
      params.type = "121";
      this.loading = true;
      queryGoodsSalesEcharts({ params, type: 121 })
        .then((res) => {
          if (res) {
            let total = this.getTotal(res);
            res = res.map((item) => {
              return [
                item.shop_name,
                Number(((Number(item.sku_cnt) / total) * 100).toFixed(2)),
              ];
            });
            this.shopChartOptions = [...res];
            this.setupOptions();
          }
        })
        .finally(() => (this.loading = false));
    },
    // 请求厂家数据
    getFactoryCharts(params) {
      params.type = "122";
      queryGoodsSalesEcharts({ params, type: 122 }).then((res) => {
        if (res) {
          let total = this.getTotal(res);
          res = res.map((item) => {
            return [
              item.factory,
              Number(((Number(item.sku_cnt) / total) * 100).toFixed(2)),
            ];
          });
          this.factoryChartOptions = [...res];
          this.setupOptions();
        }
      });
    },
    //活动类型
    getActiivtyCharts(params) {
      queryGoodsSalesEcharts({ params, type: 123 }).then((res) => {
        if (res) {
          let total = this.getTotal(res);
          res = res.map((item) => {
            return [
              item.activity_type_name,
              Number(((Number(item.sku_cnt) / total) * 100).toFixed(2)),
            ];
          });
          this.activityChartOptions = [...res];
          this.setupOptions();
        }
      });
    },
    // 饼图options
    setupOptions(data = []) {
      let shopCharts = {
        title: {
          zlevel: 0,
          text: "商户分布",
          rich: {
            value: {
              color: "#303133",
              fontSize: 20,
              fontWeight: "bold",
              lineHeight: 40,
            },
            name: {
              color: "#909399",
              lineHeight: 20,
            },
          },
          top: "center",
          // left: "49%",
          textAlign: "center",
          textStyle: {
            rich: {
              value: {
                color: "#303133",
                fontSize: 20,
                fontWeight: "bold",
                lineHeight: 40,
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   bottom: "5%",
        //   left: "center",
        //   itemWidth: 5,
        //   icon: "circle",
        // },
        series: [
          {
            type: "pie",
            name: "占比",
            keys: ["name", "y", "sliced", "selected"],
            data: this.shopChartOptions,
            dataLabels: {
              enabled: true,
              format:
                '<span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; max-width:30px;"> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;">{point.name}:</span> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; width:15px;">{point.percentage:.1f} %</span></span>',
              style: {
                textOverflow: "ellipsis",
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "50%",
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        lang: {
          noData: "暂无数据", // 这是会显示在页面上的问题。默认样式是垂直居中
        },
        noData: {
          // 下面写的是有默认值的数据，详情见官网
          attr: {}, //Object,没有数据标签的 SVG 属性集合
          position: { x: 0, y: 0, align: "center", verticalAlign: "middle" },
          style: { fontSize: "12px", fontWeight: "bold", color: "#666666" },
          useHTML: false,
        },
      };
      let factoryCharts = {
        title: {
          zlevel: 0,
          text: "厂家分布",
          rich: {
            value: {
              color: "#303133",
              fontSize: 20,
              fontWeight: "bold",
              lineHeight: 40,
            },
            name: {
              color: "#909399",
              lineHeight: 20,
            },
          },
          top: "center",
          left: "49%",
          textAlign: "center",
          textStyle: {
            rich: {
              value: {
                color: "#303133",
                fontSize: 20,
                fontWeight: "bold",
                lineHeight: 40,
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "5%",
          left: "center",
          itemWidth: 5,
          icon: "circle",
        },
        series: [
          {
            type: "pie",
            name: "占比",
            keys: ["name", "y", "sliced", "selected"],
            data: this.factoryChartOptions,
            dataLabels: {
              enabled: true,
              format:
                '<span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; max-width:30px;"> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;">{point.name}:</span> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; width:15px;">{point.percentage:.1f} %</span></span>',
              style: {
                textOverflow: "ellipsis",
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "50%",
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        lang: {
          noData: "暂无数据", // 这是会显示在页面上的问题。默认样式是垂直居中
        },
        noData: {
          // 下面写的是有默认值的数据，详情见官网
          attr: {}, //Object,没有数据标签的 SVG 属性集合
          position: { x: 0, y: 0, align: "center", verticalAlign: "middle" },
          style: { fontSize: "12px", fontWeight: "bold", color: "#666666" },
          useHTML: false,
        },
      };
      let activeCharts = {
        title: {
          zlevel: 0,
          text: "活动类型",
          rich: {
            value: {
              color: "#303133",
              fontSize: 20,
              fontWeight: "bold",
              lineHeight: 40,
            },
            name: {
              color: "#909399",
              lineHeight: 20,
            },
          },
          top: "center",
          // left: "49%",
          textAlign: "center",
          textStyle: {
            rich: {
              value: {
                color: "#303133",
                fontSize: 20,
                fontWeight: "bold",
                lineHeight: 40,
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "5%",
          left: "center",
          itemWidth: 5,
          icon: "circle",
        },
        // series: [
        //   {
        //     name: "",
        //     type: "pie",
        //     radius: ["40%", "70%"],
        //     avoidLabelOverlap: false,
        //     label: {
        //       // show: false,
        //       // position: "center",
        //       normal: {
        //         textStyle: {
        //           // color: "#fff",
        //         },
        //         position: "outer", //"inner", // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
        //         // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
        //         // {a}指series.name  {b}指series.data的name
        //         // {c}指series.data的value  {d}%指这一部分占总数的百分比
        //         formatter: function (params) {
        //           const { activity_type_name, percentAge } = params.data;
        //           return `${activity_type_name}`;
        //         },
        //       },
        //     },
        //     labelLine: {
        //       show: true,
        //       length: 6.8,
        //     },
        //     data: this.activityChartOptions,
        //   },
        // ],
        series: [
          {
            type: "pie",
            name: "占比",
            keys: ["name", "y", "sliced", "selected"],
            data: this.activityChartOptions,
            dataLabels: {
              enabled: true,
              format:
                '<span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; max-width:30px;"> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;">{point.name}:</span> <span style="display:block; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; width:15px;">{point.percentage:.1f} %</span></span>',
              style: {
                textOverflow: "ellipsis",
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "50%",
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        lang: {
          noData: "暂无数据", // 这是会显示在页面上的问题。默认样式是垂直居中
        },
        noData: {
          // 下面写的是有默认值的数据，详情见官网
          attr: {}, //Object,没有数据标签的 SVG 属性集合
          position: { x: 0, y: 0, align: "center", verticalAlign: "middle" },
          style: { fontSize: "12px", fontWeight: "bold", color: "#666666" },
          useHTML: false,
        },
      };

      this.shopCharts = { ...shopCharts };
      this.factoryCharts = { ...factoryCharts };
      this.activeCharts = { ...activeCharts };

      this.charts = [...[shopCharts, factoryCharts, activeCharts]];
      console.log("charts====>", this.charts);
    },
    getTotal(data) {
      let total = 0;
      data &&
        data.forEach((element) => {
          total = total + Number(element.sku_cnt);
        });
      return total;
    },
    // 请求表格数据升序/降序 汇总 125
    getTableData(params) {
      const param = {
        params,
        type: this.orderType,
      };
      this.listLoading = true;
      queryGoodsSalesEcharts(param)
        .then((res) => {
          if (res) {
            this.tableData = res;
          } else {
            this.tableData = [];
          }
        })
        .finally(() => (this.listLoading = false));
    },
    // 请求表格数据总数
    getTableTotal(list) {
      const param = {
        params: list,
        type: 125,
      };
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
          this.page.total = Number(res[0].cnt);
        } else {
          this.page.total = 0;
        }
      });
    },
    // 重置
    handleReset() {
      this.$refs.form && this.$refs.form.resetFields();
      this.formLine.date = [];
      console.log("this.formLine====.", this.formLine);
      const endData = new Date();
      endData.setDate(new Date().getDate() - 6);
      this.formLine.date.push(this.formatDate(endData));
      this.formLine.date.push(this.formatDate(new Date()));
      this.formLine = { ...this.formLine };
    },
    // 导出
    handleExport() {
      const list = this.getParam();
      list.pop();
      list.pop();
      list.pop();
      const param = {
        type: 117,
        params: list,
      };
      excelExport(param).then((res) => {});
    },
    //格式化日期：yyyy-MM-dd
    formatDate(date) {
      const myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.distribution-detail {
  .charts-row {
    display: flex;
    .chart-item {
      width: 30%;
      border-right: 1px solid #f5f5f5;
    }
  }
  .tabs-row {
    width: 100%;
    // padding: 0 20px;
    box-sizing: border-box;
  }
  // .charts-detail {
  //   max-height: 400px;
  //   overflow: hidden;
  // }
}
::v-deep .highcharts-credits {
  display: none;
}
</style>